const spacing = 4;

export default spacing;
